import { Component, Input, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core'
import { Globals } from '../../../../../../../globals';
import { ConfigurationServices } from '../../../../../services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
/**
 * Generated class for the ConfigurationRoomsCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-varitations-add-elements-selected',
    templateUrl: 'configuration-varitations-add-elements-selected.html',
})
export class ConfigurationVariationsAddElementsSelectedPage {

    @Input() variation;
    //datatable
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public fb: FormBuilder,
        public globals: Globals,
        public configurationServices: ConfigurationServices,
        public translate: TranslateService) {
    }

    delete(element) {
        var index = this.configurationServices.dishes_products_array_tmp.findIndex(x => x.UID == element.UID);
        if (index >= 0) {
            this.configurationServices.dishes_products_array_tmp.splice(index, 1);

            var variations_elements = element.variations_favourite;
            if (variations_elements == undefined) {
                variations_elements = []
            }
            var index_variation = variations_elements.findIndex(x => x.uid === this.variation.UID);
            variations_elements.splice(index_variation, 1);

            if (element.type == 'product') {

                this.configurationServices.firestore.collection('products').doc(element.UID).update({
                    'variations_favourite': variations_elements,
                });

            } else {
                this.configurationServices.firestore.collection('dish').doc(element.UID).update({
                    'variations_favourite': variations_elements,
                });
            }
            this.configurationServices.dishes_products_array_tmp = [...this.configurationServices.dishes_products_array_tmp];
        }
    }
    clickElement(event) {
        if (event.type == 'click') {
            this.delete(event.row);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-variations/configuration-variations-create/configuration-variations-create-info/configuration-variation-add-elements/configuration-varitations-add-elements-selected/configuration-varitations-add-elements-selected.ts